(function () {
  const initQuantityStepper = (stepper) => {
    const input = stepper.querySelector('input[name="updates[]"]');
    const decrease = stepper.querySelector("[data-cart-quantity-decrease]");
    const increase = stepper.querySelector("[data-cart-quantity-increase]");
    if (!input || !decrease || !increase) return;

    const currentValue = () => Math.max(1, Number.parseInt(input.value, 10) || 1);

    const setValue = (value) => {
      const nextValue = Math.max(1, value);
      input.value = String(nextValue);
      decrease.disabled = nextValue <= 1;
    };

    decrease.addEventListener("click", () => setValue(currentValue() - 1));
    increase.addEventListener("click", () => setValue(currentValue() + 1));
    input.addEventListener("change", () => setValue(currentValue()));
    input.addEventListener("wheel", (event) => event.preventDefault(), { passive: false });
  };

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-cart-quantity]").forEach(initQuantityStepper);
  });
})();
